import { SVGProps } from 'react'

export const ClockSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <g clipPath="url(#clip0_4396_9302)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.149 7.4931C19.5495 2.89359 12.0922 2.89359 7.49269 7.4931C2.89318 12.0926 2.89318 19.5499 7.49269 24.1494L6.54988 25.0922C1.42968 19.972 1.42968 11.6705 6.54988 6.55029C11.6701 1.43009 19.9716 1.43008 25.0918 6.55029L24.149 7.4931Z"
          fill="url(#paint0_linear_4396_9302)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.4931 24.1497C12.0926 28.7492 19.5499 28.7492 24.1494 24.1497C28.7489 19.5502 28.7489 12.0929 24.1494 7.49343L25.0922 6.55062C30.2124 11.6708 30.2124 19.9723 25.0922 25.0925C19.972 30.2127 11.6705 30.2127 6.55029 25.0925L7.4931 24.1497Z"
          fill="url(#paint1_linear_4396_9302)"
        />
        <path
          d="M15.0005 16.8203L14.9995 16.8203L15.0005 9.71094C15.0007 9.31823 15.3187 9 15.7114 9C16.1042 9.00003 16.4222 9.31825 16.4224 9.71094L16.4224 16L22.1089 16C22.5015 16.0002 22.8196 16.3184 22.8198 16.7109C22.8198 17.1037 22.5016 17.4227 22.1089 17.4229L15.0005 17.4229L15.0005 16.8203Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4396_9302"
          x1="11.4211"
          y1="26.8207"
          x2="14.9529"
          y2="2.05931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4396_9302"
          x1="20.221"
          y1="4.82214"
          x2="16.7013"
          y2="29.4984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_4396_9302">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
